import { createSimpleWrapper } from "../tag/createSimpleWrapper";
export const CardBody = createSimpleWrapper("div", "card-body");
